import { useCloudComputingPower } from 'store/src/stores/use-cloud-computing-power'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/bge/favicon.ico'
import footerLogo from '../../assets/image/bge/footer-logo.png'
import logo from '../../assets/image/bge/logo.png'
import bannerRight from '../../assets/image/top-credit/home/banner-right.png'
import downloadBg from '../../assets/image/top-credit/home/support-platform/download-bg.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#FFD633'
const lightPrimary = '#FFD633'
const secondaryPrimary = '#3C53FF'
const tertiaryPrimary = '#3C53FF'
const textColor = '#202630'

export const BgeDarkConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'light',
  logo: logo,
  footerLogo,
  platformName: 'BGE',
  loginShowDownload: false,
  colors: {
    lightPrimary: lightPrimary,
    hoverPrimary: primary,
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#DFB200',
    text: {
      base: '#202630',
      reverse: '#fff',
      primaryAlt: '#fff',
      secondary: '#989BA2',
      tertiary: '#A0A3A7',
    },
    cardBorder: '#d1d7e1',
    divider: '#ebeef5',
    borderSelected: '#74777B',
    sliderMenu: '#F4F5F6',
    tip: '#F6F7F9',
    bg: {
      base: '#FFFFFF',
      icon: {
        primary: '#151519',
        quaternary: '#75777A',
        secondary: '#75777A',
        trigger: '#E3E3E3',
      },
      button: {
        base: primary,
        primary: primary,
        aux: '#F6F7F9',
        disabled: '#C2C7D0',
        primaryTextColor: textColor,
        disabledTextColor: '#fff',
      },
      tag: {
        base: '#F3F4F6',
      },
      form: {
        base: '#F7F7F9',
        input: '#F7F7F9',
        modal: '#F1F3F6',
        card: '#ffffff',
      },
      mainPage: {
        base: '#FFFFFF',
        card: '#F5F5F7',
      },
      modal: {
        base: '#FFFFFF',
        card: '#ffffff',
        shadow: 'rgba(224, 227, 237, 0.9)',
      },
      secondary: '#F8F9FB',
    },
    loginBg: 'linear-gradient(243deg, #E8F3FF 0%, #FEFEFE 28.7%)',
  },
  ico,
  header: {
    base: '#000',
    color: 'rgba(255, 255, 255, 0.7)',
    boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
  },
  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },
  helpCenter: {
    serviceAgreement: '/service-agreement',
    privacyAgreement: '/privacy-policy',
  },
  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  cloud: {
    colors: {
      bg: {
        card: {
          fontColor: textColor,
        },
      },
    },
  },
} as BaseConfigSource as PlatformConfig)
